'use strict'

/**
 * @classname CopyCommentToModal
 * @classdesc モーダルにコメントをコピーする
 */
export default class CopyCommentToModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.copy-comment-to-modal')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * Clickのコールバック
	 *
	 * @memberof CopyCommentToModal
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`)
		$(this._$e.data('bs-target')).find('.comment').text(this._$e.data('comment'))
		$(this._$e.data('bs-target')).find('.organization-name').text(this._$e.data('organization-name'))
		$(this._$e.data('bs-target')).find('.modal-copy-header').text(this._$e.data('modal-copy-header'))
		$(this._$e.data('bs-target')).find('.modal-copy-apply-id').text(this._$e.data('modal-copy-apply-id'))
		$(this._$e.data('bs-target')).find('.modal-copy-name').text(this._$e.data('modal-copy-name'))
		$(this._$e.data('bs-target')).find('.modal-copy-operation-date').text(this._$e.data('modal-copy-operation-date'))
	}
}
